import React from 'react';
import ImprimirOCompra from '../../../components/insumos/orden_compra/ImprimirOCompra';

const ImprimirOCompraPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
        <h2>Comprobante Orden de Compra</h2>
        <ImprimirOCompra />
    </div>
  );
};

export default ImprimirOCompraPage;